import { ICustomAutoCompleteSearch } from './types';

interface IRemoveDuplicatedAirports {
  currentItems: ICustomAutoCompleteSearch[] | undefined;
  newItems: ICustomAutoCompleteSearch[];
}

export function storeDataInLocalStorage(key: string, value: string): void {
  localStorage.setItem(key, value);
}

export function getDataFromLocalStorage(key: string): string | null {
  return localStorage.getItem(key);
}

export function removeDuplicatedAirports({
  currentItems,
  newItems,
}: IRemoveDuplicatedAirports): ICustomAutoCompleteSearch[] {
  let itemsToSave: ICustomAutoCompleteSearch[] = [];

  if (!currentItems?.length) {
    return newItems;
  }

  newItems.forEach((newItem) => {
    const itemAlreadyExists = currentItems.find(
      (prevItem) => prevItem.code === newItem.code
    );

    if (!itemAlreadyExists) {
      itemsToSave = [...itemsToSave, newItem];
    }
  });

  if (itemsToSave.length < 1) {
    return currentItems;
  }

  const newValue = [...itemsToSave, ...currentItems];
  return newValue;
}
